/* eslint-disable jsx-a11y/anchor-is-valid */
import {SnackbarProvider, enqueueSnackbar} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import Swal from 'sweetalert2'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {BookingNoteModel} from '../../../../models/booking.model'
import {
  deleteBookingNotesService,
  getBookingNotesService,
} from '../../../../services/booking.service'
import {ModalEditNote} from '../Modals/ModalEditNote'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableBookingNotes: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, selectedOn} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [showModal, setShowModal] = useState(false)
  const [createdModal, setCreatedModal] = useState(false)
  const [noteToEdit, setNoteToEdit] = useState<BookingNoteModel | any>(null)

  const handleNew = () => {
    setShowModal(true)
    setCreatedModal(true)
  }

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const getNotes = async () => {
    setLoading(true)
    const {data: response} = await getBookingNotesService({
      ReservaId: currentTabItem.idToEdit,
      pageNumber: pagination.currentPage,
      size: pagination.perPage,
    })
    if (!response.error) {
      setData(response.data)
      setPagination({
        ...pagination,
        totalResults: response.total,
      })
    }
    setLoading(false)
  }

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const item = selectedOn.length > 0 ? selectedOn[0] : null
        if (item) {
          const {data: response} = await deleteBookingNotesService(item)
          if (!response.error) {
            getSnackBarToast('Se eliminó satisfactoriamente', 'success')
            getNotes()
          } else {
            getSnackBarToast(response.message, 'error')
          }
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleEdit = (item: BookingNoteModel) => {
    setNoteToEdit(item)
    setShowModal(true)
    setCreatedModal(false)
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getNotes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(false)
    getNotes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<BookingNoteModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro de Nota' />,
      accessor: 'NumeroNota',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Nota' />,
      accessor: 'TipoNotaDescripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nota' />,
      accessor: 'Nota',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Registro de Nota' />,
      accessor: 'FechaRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Usuario de Registro de Nota' />,
      accessor: 'UsuarioRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) =>
        isAllowed('NOTAS/EDITAR') ? (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleEdit(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
            </a>
          </div>
        ) : (
          <></>
        ),
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('NOTAS/AGREGAR') && (
            <button type='button' className='btn btn-success me-3' onClick={handleNew}>
              Agregar
            </button>
          )}
          {isAllowed('NOTAS/ELIMINAR') && (
            <button
              className='btn btn-primary me-3'
              disabled={selectedOn.length < 1}
              onClick={handleDelete}
              type='button'
            >
              Eliminar
            </button>
          )}
        </div>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <SnackbarProvider />
        {showModal ? (
          <ModalEditNote
            show={showModal}
            setShow={setShowModal}
            noteToEdit={noteToEdit}
            getNotes={getNotes}
            created={createdModal}
          />
        ) : (
          <></>
        )}
      </KTCard>
    </>
  )
}

const TableBookingNotesWrapper = () => {
  return (
    <KTableProvider>
      <TableBookingNotes />
    </KTableProvider>
  )
}

export {TableBookingNotesWrapper}
